<template>
	<!-- 查看弹窗 -->
	<div v-if="vdata&&vdata.isShow">
	    <div class="mask check-log">
	        <div class="e-modal medium">
	            <div class="e-modal-title">查看 <i class="e-modal-close" @click="vdata.isShow=false"></i></div>
	            <div class="e-modal-body">
	                <table class="check-log-table" cellspacing="0">
	                    <tr>
	                        <td>序号</td>
	                        <td>订单号</td>
	                        <td>操作员</td>
	                     
	                        <td>操作描述</td>
	                        <td>备注</td>
	                        <td>操作时间</td>
	                    </tr>
	                    <tr v-for="(item,index) in logList">
	                    	<td>{{index+1}}</td>
	                        <td>{{item.PurchaseOrderId}}</td>
	                   
	                        <td>（{{item.Operator}}）</td>
	                        <td>{{item.OperatorType}}</td>
	                 
	                        <td>{{item.Reamrks||'无'}}</td>
	                        <td>{{item.OperatorDate|dateLong}}</td>
	                    </tr>
	                    <tr v-if="!logList||logList.length<=0">
	                    	<td colspan="6">没有相关日志</td>
	                    </tr>
	                    <tr v-if="logList.length>0">
	                        <td></td>
	                        <td></td>
	                        <td></td>
	                        <td></td>
	                      
	                        <td></td>
	                        <td></td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>
    </div>
</template>
<script>
export default {
	name: 'orderView',
	props:{
        vdata: {
            type: Object,
 			default: function(){
                return {}
            }
        }
  	},
  	data(){
  		return {
  			logList:[]
  		}
  	},
  	watch:{
  		vdata(val,old){
			if(val!=old){
				this.getLogs();
			}
  			
  		}
  	},
  	methods:{
		getLogs(){
			var that=this;
		
	        var params={
	          purchaseOrderId: that.vdata.PurchaseOrderId
	        }
	        that.getRequest({
	            url: that.Api.getOrderLogs,
	            params: params
	        }).then(res => {
	        	
	        	if(res&&res.IsSuccess){
					that.logList=res.Result
	        	}else{
	        		that.logList=[]
	        	}
	        
	        });
		}
  	}


}
</script>


// WEBPACK FOOTER //
// src/components/order/OrderView.vue